import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';
import ContractAuthenticationStatus from '@app/store/contract-authentication/ContractAuthenticationStatus';

export interface NewDocumentsParticipantsVerificationAttemptResponse {
  id: string;
  verificationKey: string;
  failureCount: number;
  lastFailedAt?: string;
  methodType: 'PASSWORD';
  status: Uppercase<ContractAuthenticationStatus>;
}

/**
 * POST 인증
 *
 * Endpoint response, request, and path are in standardize-document-content
 * @see https://www.notion.so/modusign/bb8e24e723434ecc946dfecb85db5ee3#9e5efd1351f2460eb87e7ac23d4ba291
 */
// eslint-disable-next-line import/prefer-default-export
export function postDocumentsParticipantVerificationAttempt({
  verificationKey,
  methodType,
  passValue,
  documentId,
  participantId,
  workspaceId,
}: {
  verificationKey: string;
  methodType: 'PASSWORD';
  passValue: string;
  documentId: string;
  participantId: string;
  workspaceId: string;
}): Promise<NewDocumentsParticipantsVerificationAttemptResponse> {
  return requestApi<NewDocumentsParticipantsVerificationAttemptResponse>({
    url: withDocument(
      `/workspaces/${workspaceId}/documents/${documentId}/participants/${participantId}/verification/attempt`
    ),
    method: 'POST',
    data: {
      verificationKey,
      methodType,
      passValue,
    },
    credentials: true,
  }).then((response) => response.data);
}
